import getTemplate from './bk-button-secondary-template.js';
import './styles.scss';

class BkButtonSecondary extends HTMLElement {
    #buttonText;
    #hasBorder = false;

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['bk-text', 'bk-border'];
    }

    attributeChangedCallback(property, oldValue, newValue) {
        if (!BkButtonSecondary.observedAttributes.includes(property) || oldValue === newValue) {
            return;
        }

        switch (property) {
            case 'bk-text':
                this.#buttonText = newValue;
                this.#updateButtonText();
                break;
            case 'bk-border':
                if (this.#hasBorder) {
                    return;
                }
                this.#hasBorder = newValue === 'true';
                this.#setBorderClass();
                break;
        }
    }

    #updateButtonText() {
        if (!this.querySelector('button')) {
            return;
        }
        this.querySelector('button').textContent = this.#buttonText;
    }

    #setBorderClass() {
        if (!this.querySelector('button')) {
            return;
        }
        this.querySelector('button').classList.add('bk-button-secondary--border');
    }

    connectedCallback() {
        const content = getTemplate(this.#buttonText, this.#hasBorder).content.cloneNode(true);
        this.replaceChildren(content);
    }
}

export default BkButtonSecondary;
